import { render } from "./AnonymousView.vue?vue&type=template&id=2746f5ee"
import script from "./AnonymousView.vue?vue&type=script&lang=js"
export * from "./AnonymousView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__